import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";

import { Context as AuthContext } from "../context/AuthContext";

const AuthenticatedRoute = ({ component: Component, isLogin, ...rest }) => {
  const {
    state: { isAuthenticated },
  } = useContext(AuthContext);
  const { path } = { ...rest };

  if (
    path === "/login" ||
    path === "/password-recovery" ||
    path === "/password-reset"
  ) {
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated ? (
            <Redirect to={{ pathname: "/", state: { from: props.location } }} />
          ) : (
            <Component {...props} />
          )
        }
      ></Route>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    ></Route>
  );
};

export default AuthenticatedRoute;
